import {pageTitleStyles} from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { css } from "styled-components";

pageTitleStyles.brandGridItem = {
    width: 0,
}

pageTitleStyles.titleText = {
    size: 28,
    variant: "h2",
    css: css`
        margin-bottom: 0;`,
}

